import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import classnames from 'classnames'
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import { years_list, months_list } from "../../Shared/List";
import SelectField from "../../Shared/SelectField";
import { FaFileExport, FaTimes } from "react-icons/fa"
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const BranchPayroll = (props) => {
    const current_user = JSON.parse(localStorage.getItem('user'))
    const billing_date  = current_user?.branch?.billing_date

    const [errors, setErrors] = useState([]);
    const [data, setData] = useState([]);
    const [title, setTitle] = useState('');
    const [pinnedBottomRowData, setPinnedBottomRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const gridRef = useRef();
    const [show, setShow] = useState(false);
    const [publicID, setPublicID] = useState()
    const [yearOptions, setYearOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [formData, setFormData] = useState({
        year: billing_date.year,
        month: billing_date.month,
    });
    const {year, month} = formData;

    const navigate = useNavigate()

    useEffect(() => {

        const years = []
        const months = []
        years_list.map(year => (
            years.push({
                id: year.id,
                name: year.name,
                key: year.key
            })
        ))

        months_list.map(month => (
            months.push({
                id: month.id,
                name: month.name,
                key: month.key
            })
        ))

        setYearOptions(years)
        setMonthOptions(months)
        
        fetchData()
    }, []);

    const handleClose = () => {
        setShow(false)
    }
    const handleShow = (public_id) => {
        setShow(true)
        setPublicID(public_id)
    };

    const handleDelete = async (public_id) => {
        setShow(false)
        try {
            setIsLoading(true)
            const response = await Server.delete(`/payrolls/branch/${public_id}`)
            toast.success(response.data.detail)
            setData(data.filter((payroll) => payroll.public_id !== public_id))
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else{
                toast.error(error.response.data?.detail)
            }
        }
    }

    const [columnDefs] = useState([
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        
        {
            headerName: "Name",
            field: "company_name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Branch",
            field: "branch_name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Prev.Balance",
            field: "previous_balance",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Debit",
            field: "debit",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Total",
            field: "total",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Credit",
            field: "credit",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Balance",
            field: "balance",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Cancel",
            cellRenderer: (e) => { 
                if (e.node.rowPinned) return ''; // do not display button on rowPinned
                return <button className={classnames('btn btn-outline-danger', {'disabled' : e.data.credit > 0})} onClick={()=> handleShow(e.data.public_id)}><FaTimes/></button>},
            sortable: false,
            filter: false,
        }
    ]);

    const fetchData = async () => {
        setTitle(`${months_list[month -1].name}, ${year} Payroll Summary`)
        setIsLoading(true)
        try {
            const response = await Server.get(`/payrolls/branches?year=${year}&month=${month}`)
            setData(response?.data);
            setIsLoading(false);

            const output = response?.data.reduce((data, row) => {
                data.previous_balance += parseFloat(row.previous_balance);
                data.debit += parseFloat(row.debit);
                data.total += parseFloat(row.total);
                data.credit += parseFloat(row.credit);
                return data;
            }, {previous_balance: 0.00, debit: 0.00, total: 0.00, credit: 0.00, balance: 0.00});
            setPinnedBottomRowData([
                {
                    previous_balance: parseFloat(output.previous_balance).toFixed(2),
                    debit: parseFloat(output.debit).toFixed(2),
                    total: parseFloat(output.total).toFixed(2),
                    credit: parseFloat(output.credit).toFixed(2),
                    balance: (output.total - output.credit).toFixed(2),
                }
            ]);
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data)
            }
        }
    }

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()
        
        fetchData()
    };

    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
    
    const onExportClick=() => {
        gridApi.exportDataAsCsv({ fileName: `${title}.csv` })
    }

    const getRowStyle = (params) => {
        if (params.node.rowPinned) {
          return {
            backgroundColor: '#f8f9fa',
            fontWeight: 'bold',
            color: '#000',
          };
        }
        return {};
    };

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-md-2">
                    <SelectField
                        name="year"
                        value={parseInt(year)}
                        options={yearOptions}
                        onChange={onChange}
                        error={errors.year}
                    />
                </div>
                <div className="col-md-2">
                    <SelectField
                        name="month"
                        value={parseInt(month)}
                        options={monthOptions}
                        onChange={onChange}
                        error={errors.month}
                    />
                </div>
                <div className="col-md-6">
                    <input type="submit" className="btn btn-info mt-1" value="Apply Filter" style={{float: 'left'}}/>
                </div>
                <div className="col-md-2">
                    <button onClick={()=>onExportClick()} className="btn btn-success mb-2" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
                </div>
            </div>
            <br/>
        </form>
        <div className="card">
    
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
            <div className="row">
                <div className="col-md-12">
                    <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            suppressMenuHide={true}
                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            rowData={data}
                            domLayout={"normal"}
                            rowSelection={"multiple"}
                        
                            pagination={false}
                            onGridReady={onGridReady}
                        
                            resizable={true}
                            animateRows={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}
                        
                        
                            ref={gridRef}
                            pinnedBottomRowData={pinnedBottomRowData}
                            getRowStyle={getRowStyle}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
        <Modal.Title>Delete Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure?</Modal.Body>
        <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
            No
        </Button>
        <Button variant="danger" onClick={() => handleDelete(publicID)}>
            Yes
        </Button>
        </Modal.Footer>
    </Modal>
    <br/>
    </>
  )
}

export default BranchPayroll
